
import GwSection from '~/patterns/organisms/section/section';
import GwVideoEmbed from '~/patterns/molecules/video-embed/video-embed';

export default {
    components: {
        GwSection,
        GwVideoEmbed
    },

    props: {
        videoUrl: {
            type: String,
            default: null
        },

        caption: {
            type: String,
            default: null
        },

        heading: {
            type: String,
            required: false,
            default: null
        }
    }
};
